import React from "react";
import InputText from "./InputText";

/**
 * For MUI Autocomplete / TimePicker / DatePicker `renderInput={(params) => ...}`.
 * Forwards InputProps.ref and inputProps so the picker/autocomplete attaches correctly.
 */
function RenderParamsInputText({
  params,
  label: labelProp,
  required,
  name,
  size,
  fieldHeight,
  helperText,
  error: errorProp,
  ...rest
}) {
  if (!params) return null;
  const InputProps = params.InputProps || {};
  const { ref: inputRefFromMui, ...inputPropsRest } = InputProps;
  const label =
    labelProp ??
    (typeof params.label === "string" ? params.label : undefined);

  const hasError =
    errorProp !== undefined
      ? Boolean(errorProp)
      : Boolean(params.error);

  return (
    <InputText
      {...rest}
      id={params.id}
      name={name ?? params.name}
      label={label}
      required={required}
      fullWidth={params.fullWidth !== false}
      inputRef={inputRefFromMui}
      InputProps={inputPropsRest}
      inputProps={params.inputProps}
      error={hasError}
      helperText={helperText}
      disable={Boolean(params.disabled)}
      fieldHeight={fieldHeight || "44px"}
      InputLabelProps={params.InputLabelProps}
    />
  );
}

export default RenderParamsInputText;
